import { gql } from '@apollo/client'

import { OPERATING_DAY_FRAGMENT } from '../../operatingDay'
import { SHOP_DRIVER_TIP_VARIANT_FRAGMENT } from '../driverTipVariants'

export const SHOP_CART_FULFILLMENT_SCHEDULE_SETTING_FRAGMENT = gql`
  fragment ShopCartFulfillmentScheduleSetting on ShopCartFulfillmentScheduleSettingInterface {
    ... on ShopCartFulfillmentDeliverySetting {
      fulfillmentOperatingDay {
        ...OperatingDay
      }
      deliveryType
      disableTimeSelector
      driverTipVariants {
        ...ShopDriverTipVariant
      }
    }
  }

  ${SHOP_DRIVER_TIP_VARIANT_FRAGMENT}
  ${OPERATING_DAY_FRAGMENT}
`
